import styled from "styled-components";

export const BtnSearchBtn = styled.button`
    cursor: pointer;
    border: 1px solid transparent;
    line-height: 32px;
    padding: 0 15px;
    text-align: center;
    font-weight: 500;
    height: 32px;
    border-radius: 4px;
    background: ${(props) => props.background || '#f4f5f6'};
    display: ${(props) => props.display || 'block'};

    &:active {
        transform: scale(0.95); /* 클릭 시 크기 축소 */
    }

    &:hover {
        border: 1px hsl(240 3% 74%) solid;
    }
`;
export const BtnBasicBtn = styled.button`
  cursor: pointer;
  border: 2px solid #31a23a;
  color: #31a23a;
  background: #bbe8be;
  border-radius: 1px;
  padding: 0 15px;
  text-align: center;
  height: 30px;
  margin-right: 5px;
  position: relative;
  z-index: 1;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  -ms-transition: all 0.4s;
  -o-transition: all 0.4s;
  transition: all 0.4s;
  &:after{
    content: "";
    width: 0%;
    height: 100%;
    top: 0;
    position: absolute;
    left: 0;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -ms-transition: all 0.2s;
    -o-transition: all 0.2s;
    transition: all 0.2s;
    background: #31a23a;
  }
  &:hover{
    color: white;
  }
  &:hover:after{
    width: 100%;
    z-index: -1;
  }
`;

export const BtnAddressSearchBtn = styled.button`
  cursor: pointer;
  border: 2.5px solid #436bb4;
  background-color: #5b8ae0;
  line-height: 24px;
  padding: 0 15px;
  color: white;
  min-width: 120px;
  text-align: center;
  height: 30px;
  margin: 0 20px;
`;

export const DrawerTrigger = styled.button`
    cursor: pointer;
    border: 1px solid black;
    line-height: 30px;
    padding: 0 20px;
    text-align: center;
    width: 4.5rem;
    height: 30px;
    margin-right: 5px;
    background: white;
    outline: none;
`;